import React from "react";

const RISK_LABELS = {
  clarity_risk: "Clarity",
  budget_opacity_risk: "Budget opacity",
  delegated_power_risk: "Delegated power",
  implementation_ambiguity_risk: "Implementation ambiguity",
  conflict_risk: "Conflict potential",
  loophole_exemption_risk: "Loopholes / exemptions",
  bait_and_switch_risk: "Bait-and-switch signals",
};

export default function RiskScorecard({ riskLabels }) {
  if (!riskLabels || Object.keys(riskLabels).length === 0) {
    return (
      <div className="text-sm text-[hsl(var(--ink-muted))]" data-testid="risk-empty">
        No risk signals available yet.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="risk-scorecard">
      {Object.entries(RISK_LABELS).map(([k, label]) => {
        const item = riskLabels[k] || { score: 1, drivers: [] };
        const score = Math.max(1, Math.min(5, item.score || 1));
        return (
          <div key={k} className="paper-card p-3 rounded-sm" data-testid={`risk-${k}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="section-label mb-0.5">{label}</div>
                <div className="text-xs text-[hsl(var(--ink-muted))] mt-1">
                  {item.drivers && item.drivers.length > 0
                    ? item.drivers.slice(0, 2).join(" · ")
                    : "No pattern matches detected."}
                </div>
              </div>
              <div className="risk-bar shrink-0" title={`${score} of 5`}>
                {[1, 2, 3, 4, 5].map((i) => (
                  <span
                    key={i}
                    className={`risk-tick ${i <= score ? "on" : ""} ${
                      i <= score && score >= 4 ? "severe" : i <= score && score >= 3 ? "high" : ""
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      })}
      <p className="col-span-full text-[11px] text-[hsl(var(--ink-muted))] font-mono uppercase tracking-wider mt-1">
        Reading-complexity warnings — not moral judgments.
      </p>
    </div>
  );
}
